// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Element } from 'react-scroll/modules';
import AlertContainer from '../../../alert/container/AlertContainer';
import NewFlightForm from '../NewFlightForm/NewFlightForm';
import { searchLocationApi } from '../../api';
import Slider from 'react-slick/lib';
import Arrow from '../../../../elements/Arrow/Arrow';
import { Default, Mobile } from '../../../../utils/responsive';

import style from './NewFlightContent.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import billOne from '../../../../assets/img/new-flight/landing/bill_one.png';
import handLuggageB from '../../../../assets/img/new-flight/landing/hand_luggage_b.png';
import billTwo from '../../../../assets/img/new-flight/landing/bill_two.png';
import stepOne from '../../../../assets/img/new-flight/landing/steps/step_one.png';
import stepOneBill from '../../../../assets/img/new-flight/landing/steps/step_one_bill.png';
import stepTwo from '../../../../assets/img/new-flight/landing/steps/step_two.png';
import stepTwoBill from '../../../../assets/img/new-flight/landing/steps/step_two_bill.png';
import stepThree from '../../../../assets/img/new-flight/landing/steps/step_three.png';
import icons from '../../../../assets/styles/icons.scss';

import type { User } from '../../../../entities';
import type { LocaleState } from '../../../locale/duck';
import type { LocalValuesState } from '../../../local-values/duck';
import type { HTTPError } from '../../../../error';
import type { TravelerStep } from '../NewFlight';
import CarouselTestimonials
  from '../../../../elements/CarouselTestimonials/CarouselTestimonials';
import { Link } from 'react-router-dom';

type Props = {
  +authenticated?: boolean;
  +user?: User;
  +locale: LocaleState;
  +localValues: LocalValuesState;
  +postFlight: (flightDate: string, departureCountry: string, departureAdmin1: number,
                departureAdmin2: number, arrivalCountry: string, arrivalAdmin1: number,
                arrivalAdmin2: number) => void;
  +isPosting?: boolean;
  +postError?: HTTPError;
  +handleOpenAuthModal: (openLoginView?: boolean) => void;
  +authModalVisible?: boolean;
  +travelerSteps: TravelerStep[];
  +benefits: { [string]: string }[];
  +isBrowser: boolean;
  +postPhone: (phone: string, country: string, enableSmsNotifications: boolean) => void;
};

type State = {
  greyLeftArrow: boolean;
  greyRightArrow: boolean;
};

export default class NewFlightContent extends Component<Props, State> {
  state = {
    greyLeftArrow: false,
    greyRightArrow: true,
  };

  buildBenefitsBox = (benefit: { [string]: string }, i: number): Element<'article'> => (
    <article key={i}
             className={style.box}>
      <img src={benefit.img} alt="benefit" draggable="false"/>
      <FormattedMessage id={benefit.id}>{
        txt => <p className={style.subtitle}>{txt}</p>
      }</FormattedMessage>
    </article>
  );


  handleGreyArrows(currentSlide: number) {
    const greyLeftArrow = currentSlide !== 0;
    const greyRightArrow = currentSlide !== this.props.benefits.length - 1;
    this.setState({ greyLeftArrow, greyRightArrow })
  }

  render() {
    const {
      locale, postFlight, isPosting, postError, handleOpenAuthModal, authenticated, 
      user, authModalVisible, localValues, travelerSteps, benefits, isBrowser, postPhone,
    } = this.props;
    const { greyLeftArrow, greyRightArrow } = this.state;
    const settings = {
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      dots: true,
      arrows: true,
      draggable: true,
      dotsClass: classNames('slick-dots', style.dots),
      nextArrow: <Arrow icon={icons.iconChevronRightMedium}
                        positionClass={classNames(style.arrowRight, { [style.grey]: !greyRightArrow })}
                        visible={true}/>,
      prevArrow: <Arrow icon={icons.iconChevronLeftMedium}
                        positionClass={classNames(style.arrowLeft, { [style.grey]: !greyLeftArrow })}
                        visible={true}/>,
      afterChange: (current) => this.handleGreyArrows(current),
    };
    return (
      <Fragment>
        <section className={style.banner}>
          <FormattedMessage id="newFlight.banner.title">{
            txt => <h2> {txt}</h2>
          }</FormattedMessage>
          <FormattedMessage id="newFlight.banner.subtitle">{
            txt => <p>{txt}</p>
          }</FormattedMessage>
          <section className={classNames(style.luggage, style.mobile)}>
            <img src={billTwo}
                 alt="billTwo"
                 className={classNames(style.bill, style.two)}/>
            <img src={handLuggageB}
                 alt="handLuggageB"/>
            <img src={stepOneBill}
                 alt="stepOneBill"
                 className={classNames(style.bill, style.stepOne)}/>
          </section>
          <section className={style.newFlight}>
            <NewFlightForm locale={locale.locale}
                           localValues={localValues}
                           authenticated={authenticated}
                           user={user}
                           authModalVisible={authModalVisible}
                           handleOpenAuthModal={handleOpenAuthModal}
                           searchLocation={searchLocationApi}
                           postFlight={postFlight}
                           postPhone={postPhone}
                           isPosting={isPosting}
                           postError={postError}
                           mode="create"
                           abTest/>
          </section>
          <section className={classNames(style.luggage, style.default)}>
            <img src={billTwo}
                 alt="billTwo"
                 className={classNames(style.bill, style.two)}/>
            <img src={handLuggageB}
                 alt="handLuggageB"/>
            <img src={stepOneBill}
                 alt="stepOneBill"
                 className={classNames(style.bill, style.stepOne)}/>
          </section>
        </section>
        <section className={style.travelerSteps}>
          <FormattedMessage id="newFlight.infoSteps.title">{
            txt => <h2>{txt}</h2>
          }</FormattedMessage>
          <article>
            <img src={stepOne} alt="stepOne"/>
            <section>
              <div>
                <p className={style.step}>1</p>
                <FormattedMessage id={travelerSteps[0].title}>{
                  txt => <h4>{txt}</h4>
                }</FormattedMessage>
              </div>
              <FormattedMessage id={travelerSteps[0].text}>{
                txt => <p className={style.text}>{txt}</p>
              }</FormattedMessage>
            </section>
          </article>
          <img className={classNames(style.bill, style.stepOne)}
               src={stepOneBill} alt="stepOneBill"/>
          <article>
            <section className={style.desktop}>
              <div>
                <p className={style.step}>2</p>
                <FormattedMessage id={travelerSteps[1].title}>{
                  txt => <h4>{txt}</h4>
                }</FormattedMessage>
              </div>
              <FormattedMessage id={travelerSteps[1].text}>{
                txt => <p className={style.text}>{txt}</p>
              }</FormattedMessage>
            </section>
            <img src={stepTwo} alt="stepTwo"/>
            <section className={style.mobile}>
              <div>
                <p className={style.step}>2</p>
                <FormattedMessage id={travelerSteps[1].title}>{
                  txt => <h4>{txt}</h4>
                }</FormattedMessage>
              </div>
              <FormattedMessage id={travelerSteps[1].text}>{
                txt => <p className={style.text}>{txt}</p>
              }</FormattedMessage>
            </section>
          </article>
          <img className={classNames(style.bill, style.stepTwo)}
               src={stepTwoBill} alt="stepTwoBill"/>
          <article>
            <img src={stepThree} alt="stepThree"/>
            <section>
              <div>
                <p className={style.step}>3</p>
                <FormattedMessage id={travelerSteps[2].title}>{
                  txt => <h4>{txt}</h4>
                }</FormattedMessage>
              </div>
              <FormattedMessage id={travelerSteps[2].text}>{
                txt => <p className={style.text}>{txt}</p>
              }</FormattedMessage>
            </section>
          </article>
        </section>
        <section className={style.benefitsWrap}>
          <FormattedMessage id="newFlight.benefits.title">{
            txt => <p className={style.title}>{txt}</p>
          }</FormattedMessage>
          <Mobile>
            <section className={style.benefits}>
              <Slider {...settings}>
                {benefits.map((benefit: { [string]: string }, i: number) =>
                  <section key={i}>
                    {this.buildBenefitsBox(benefit, i)}
                  </section>)}
              </Slider>
            </section>
          </Mobile>
          <Default>
            <section className={style.benefits}>
              {benefits.map((benefit: { [string]: string }, i: number) => this.buildBenefitsBox(benefit, i))}
            </section>
          </Default>
        </section>
        <section className={style.testimonialsWrap}>
          <FormattedMessage id="home.testimonialsBlock.traveler.title">{
            txt => <h2 className={style.title}>{txt}</h2>
          }</FormattedMessage>
          {isBrowser && <CarouselTestimonials userType="traveler"
                                              country={locale.domainCountry}/>}
          <FormattedMessage id="home.testimonialsBlock.traveler.seeMore">{
            txt => <Link className={style.tabletAndDesktop}
                         to="/testimonials/travelers">{txt}</Link>
          }</FormattedMessage>
          <Mobile>
            <section className={style.button}>
              <FormattedMessage id="home.testimonialsBlock.traveler.seeMore">{
                txt => <Link className={classNames(buttonStyle.btn, buttonStyle.greyInverse)}
                             to="/testimonials/travelers">{txt}</Link>
              }</FormattedMessage>
            </section>
          </Mobile>
        </section>
      </Fragment>
    );
  }
}

NewFlightContent.propTypes = {
  authenticated: PropTypes.bool,
  user: PropTypes.object,
  locale: PropTypes.object.isRequired,
  localValues: PropTypes.object,
  postFlight: PropTypes.func.isRequired,
  isPosting: PropTypes.bool,
  postError: PropTypes.object,
  handleOpenAuthModal: PropTypes.func.isRequired,
  authModalVisible: PropTypes.bool,
  travelerSteps: PropTypes.array.isRequired,
  benefits: PropTypes.array.isRequired,
  isBrowser: PropTypes.bool.isRequired,
  postPhone: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/new-flight/components/NewFlightContent/NewFlightContent.jsx